export function unwrapWebsiteBuilderApiData(response) {
    if (!(response === null || response === void 0 ? void 0 : response.data) || !Object.prototype.hasOwnProperty.call(response.data, "data")) {
        throw new Error("Website Builder API response missing data");
    }
    return response.data.data;
}
